import { ApplicationConfig, provideExperimentalZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../services/token-interceptor';
import { TokenService } from '../services/auth-token-service';
import { HttpLoaderInterceptor } from '../services/http-loader-interceptor';

// Try to determine basePath to accommodate development and not development cases
const maybeLang = window.location.pathname.split('/')[1];
const isLang = maybeLang.startsWith('en') || maybeLang.startsWith('pl');
const basePath = `${window.location.origin}` + (isLang ? '/' + maybeLang : '');

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: TokenService,
      useFactory: () => {
        return new TokenService({
          configLoader: () => {
            return fetch('/env-config.json')
              .then((r) => r.json())
              .then((cfg) => {
                const authCallback = `${basePath}${cfg['oidc']['redirectRoute']}`;
                return {
                  ...cfg['oidc'],
                  redirectUrl: authCallback,
                };
              });
          },
        });
      },
    },

    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
    ),
    provideAnimations(),
    provideLuxonDateAdapter({
      parse: {
        dateInput: 'yyyy-LL-dd',
      },
      display: {
        dateInput: 'yyyy-LL-dd',
        monthYearLabel: 'LLLL',
        dateA11yLabel: 'yyyy-LL-dd',
        monthYearA11yLabel: 'LLLL yyyy',
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
};
